import { useEffect, useRef, useState } from 'react';
import { geoDist } from './geo';
import { bearingDeg } from './stake';
import { mPerLat, mPerLon } from './geo';

export const HEAD_MODES = ['north', 'walk', 'compass'];
const sensor = (e) => (e.webkitCompassHeading != null ? e.webkitCompassHeading : e.alpha != null && (e.absolute || e.type === 'deviceorientationabsolute') ? (360 - e.alpha + (window.screen?.orientation?.angle || 0)) % 360 : null);
// circular spread (°) of recent compass readings
export const spread = (a) => { if (a.length < 4) return 0; const s = a.reduce((v, x) => v + Math.sin((x * Math.PI) / 180), 0) / a.length, c = a.reduce((v, x) => v + Math.cos((x * Math.PI) / 180), 0) / a.length; return (Math.sqrt(-2 * Math.log(Math.max(1e-9, Math.hypot(s, c)))) * 180) / Math.PI; };

// direction reference for stakeout: north-up (0), walking direction from positions, or phone compass
export function useHeading(mode, pos) {
  const [h, setH] = useState(null);
  const [unstable, setUnstable] = useState(false);
  const trail = useRef([]), buf = useRef([]), last = useRef(0);
  useEffect(() => {
    setH(null); trail.current = []; buf.current = [];
    if (mode !== 'compass') return undefined;
    const ev = 'ondeviceorientationabsolute' in window ? 'deviceorientationabsolute' : 'deviceorientation';
    const on = (e) => {
      const v = sensor(e), now = Date.now();
      if (v == null || now - last.current < 150) return;
      last.current = now; buf.current = [...buf.current.slice(-9), v];
      setH(v); setUnstable(spread(buf.current) > 20 || (e.webkitCompassAccuracy != null && e.webkitCompassAccuracy > 25));
    };
    const D = window.DeviceOrientationEvent;
    if (D && typeof D.requestPermission === 'function') D.requestPermission().catch(() => {});
    window.addEventListener(ev, on);
    return () => window.removeEventListener(ev, on);
  }, [mode]);
  useEffect(() => {
    if (mode !== 'walk' || !pos) return;
    const tr = trail.current, p = [pos.lat, pos.lon];
    if (!tr.length || geoDist(tr[tr.length - 1], p) >= 0.3) trail.current = [...tr.slice(-5), p];
    const a = trail.current[0], b = trail.current[trail.current.length - 1];
    if (a && b && geoDist(a, b) >= 1) setH(bearingDeg((b[0] - a[0]) * mPerLat(a[0]), (b[1] - a[1]) * mPerLon(a[0])));
  }, [pos, mode]);
  return { h: mode === 'north' ? 0 : h, unstable: mode === 'compass' && unstable };
}
